export const minimumViewsCountToShow = 1000;
export const minimumCommentsCountToShow = 1;
export const minimumLikesCountToShow = 1;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/InteractionsGroup/constants.js